// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

export const HISTORY_INDEX_KEY = "riddleScreenFocusIndex";

export function readHistoryIndex(state: unknown): number | undefined {
  if (state === null || typeof state !== "object") {
    return undefined;
  }
  const value = (state as Record<string, unknown>)[HISTORY_INDEX_KEY];
  return typeof value === "number" ? value : undefined;
}

export function nextHistoryState(): Record<string, number> {
  return { [HISTORY_INDEX_KEY]: (readHistoryIndex(window.history.state) ?? 0) + 1 };
}

export function currentHistoryState(): Record<string, unknown> {
  const state: unknown = window.history.state;
  return state !== null && typeof state === "object" ? { ...(state as Record<string, unknown>) } : {};
}

export function pushHistoryEntry(url: string): void {
  window.history.pushState(nextHistoryState(), "", url);
}

export function replaceHistoryEntry(url: string): void {
  window.history.replaceState(currentHistoryState(), "", url);
}

export type PopStateGuard = (event: PopStateEvent) => boolean;

const popStateGuards = new Set<PopStateGuard>();

export function addPopStateGuard(guard: PopStateGuard): () => void {
  popStateGuards.add(guard);
  return () => {
    popStateGuards.delete(guard);
  };
}

window.addEventListener(
  "popstate",
  (event) => {
    for (const guard of popStateGuards) {
      if (guard(event)) {
        event.stopImmediatePropagation();
        return;
      }
    }
  },
  true,
);
